var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplaceUtglWeb = function SvgReplaceUtglWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Replace_UTGL_Web_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#305992"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 16H2.508v-3.007h2.983v1.852l3.627-2.507-3.627-2.524v1.852H2.508V3.007H18V16Zm-3.08-5.867c-.572 0-1.12.232-1.52.663a2.35 2.35 0 0 0-.63 1.603c0 .594.221 1.18.63 1.602.408.43.948.664 1.52.664.572 0 1.119-.233 1.52-.664.408-.43.628-1 .628-1.602 0-.604-.228-1.18-.629-1.603a2.078 2.078 0 0 0-1.52-.663Zm-3.17 0c-.564 0-1.12.24-1.52.663a2.35 2.35 0 0 0-.63 1.603c0 .594.221 1.18.63 1.602.408.422.947.664 1.52.664a2.04 2.04 0 0 0 1.29-.466l.18-.146-.18-.147a1.913 1.913 0 0 1-.719-1.516c0-.603.262-1.146.72-1.517l.18-.146-.18-.146a2.04 2.04 0 0 0-1.292-.466v.018Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.414 12.993c-.376 0-.728-.155-.997-.43A1.5 1.5 0 0 1 0 11.51V1.491C0 1.103.147.715.417.439.687.164 1.037 0 1.414 0H14.33l1.234 1.301H1.234v10.391H2.5v1.301H1.414Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Replace_UTGL_Web_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v16H0z"
  })))));
};
export default SvgReplaceUtglWeb;